// extracted by mini-css-extract-plugin
export const root = "bb_r";
export const paper = "bb_s";
export const title = "bb_x";
export const btnUpdate = "bb_w";
export const titleSection = "bb_S";
export const previewRoot = "bb_ch";
export const preview = "bb_cj";
export const previewOnDragOver = "bb_ck";
export const banner = "bb_bw";
export const bannerOnDrag = "bb_cl";
export const bannerDescription = "bb_cm";
export const closeBtn = "bb_cn";
export const subTitle = "bb_cp";
export const leafletRequirement = "bb_cq";
export const professional = "bb_cr";